export default "__VITE_ASSET__DQBSTaZ9__"